module.exports = __webpack_public_path__ + "static/img/UAV.4f66ebf1.png";